export default "__VITE_ASSET__97a6ecf7__"